import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';

function DeleteOffer(props) {
  const {
    isOpen, onClose, offerId, deleteOffer,
  } = props;
  const [modal, setModal] = useState(isOpen);

  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const hideModal = () => {
    toggle();
    onClose();
  };

  const onDeleteOffer = () => {
    deleteOffer(offerId);
    onClose();
  };

  return (
    <Modal isOpen={modal} className="modal-logout modal-logout-admin modal-dialog-centered">
      <ModalBody>
        <p className="text-left">
          Are you sure you want to delete this opportunity?
        </p>
        <div className="button-wrapper">
          <Button
            color="secondary"
            size="xs"
            className="btn-small"
            onClick={hideModal}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className="btn-small"
            onClick={() => { onDeleteOffer(); }}
          >
            Delete opportunity
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

DeleteOffer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  deleteOffer: PropTypes.func.isRequired,
};

export default DeleteOffer;
